import React from "react";
import { useIsMobile, View } from "hooks";
import MobileTabbedSection from "./MobileTabbedSection";
import DesktopTabbedSection from "./DesktopTabbedSection";

export enum Tab {
  REGISTRATION_AND_ATTENDANCE,
  CAMPSITES_AND_VISITATION,
  DRESS_CODE,
  WHAT_TO_LEAVE,
  FRIDAY_AND_SATURDAY,
  VOLUNTEER_WORK,
  VISITORS,
  SCHEDULE,
}

type TabName =
  | "Registration & Attendance"
  | "Campsites & Visitation"
  | "Dress Code"
  | "What to Leave"
  | "Friday & Saturday"
  | "Volunteer Work"
  | "Visitors"
  | "Schedule";

export const tabs: {
  [k in Tab]: TabName;
} = {
  [Tab.REGISTRATION_AND_ATTENDANCE]: "Registration & Attendance",
  [Tab.CAMPSITES_AND_VISITATION]: "Campsites & Visitation",
  [Tab.DRESS_CODE]: "Dress Code",
  [Tab.WHAT_TO_LEAVE]: "What to Leave",
  [Tab.FRIDAY_AND_SATURDAY]: "Friday & Saturday",
  [Tab.VOLUNTEER_WORK]: "Volunteer Work",
  [Tab.VISITORS]: "Visitors",
  [Tab.SCHEDULE]: "Schedule",
};

function TabbedSection() {
  const { view } = useIsMobile();

  return view === View.Mobile ? (
    <MobileTabbedSection />
  ) : (
    <DesktopTabbedSection />
  );
}

export default TabbedSection;
